import React, { PropsWithChildren } from 'react';
import { Dropdown, DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';
import { FC, useMemo, useState } from 'react';

export type SearchBarType = {
  name: string;
  icon: JSX.Element;
  value: string;
};

type Props = PropsWithChildren & {
  searchTypes: SearchBarType[];
  value: {
    search: string;
    type: string;
  };
  onChange: ({ search, type }: { search: string; type: string }) => void;
  className?: string;
};

const SearchBar: FC<Props> = ({ value, searchTypes, className, children, onChange }) => {
  const [showTypeDropdown, setShowTypeDropdown] = useState(false);

  const activeType = useMemo(() => {
    const item = searchTypes.find((t) => t.value === value.type);

    return item;
  }, [searchTypes, value.type]);

  if (!activeType) return <span>Invalid value for search type</span>;

  return (
    <div
      className={`flex border border-gray-border py-1.5 pl-3 pr-2 rounded-lg items-center ${className}`}>
      <input
        type='search'
        value={value.search}
        onChange={(e) => onChange({ ...value, search: e.target.value })}
        placeholder={`Search ${activeType.name.toLowerCase()}`}
        className='focus:outline-none grow border-none'
      />
      {children}
      <Dropdown
        visible={showTypeDropdown}
        content={
          <div
            onClick={() => setShowTypeDropdown(!showTypeDropdown)}
            className='text-gray-8 bg-gray-border cursor-pointer rounded-lg p-1.5'>
            {activeType.icon}
          </div>
        }>
        <DropdownList>
          {searchTypes.map((searchType) => (
            <DropdownItem
              onClick={() => {
                onChange({ ...value, type: searchType.value });
                setShowTypeDropdown(false);
              }}
              buttonClassName={`gap-2 py-2 ${
                searchType.value === value.type ? 'bg-[#fafafa]' : ''
              }`}
              key={searchType.value}>
              <span className='text-gray-8'>{searchType.icon}</span>
              {searchType.name}
            </DropdownItem>
          ))}
        </DropdownList>
      </Dropdown>
    </div>
  );
};

export default SearchBar;
